import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Seo from "@/components/Seo";

const Cookies = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Política de Cookies | Quimical"
        description="Saiba como a Quimical utiliza cookies para melhorar performance, funcionalidade e personalização no site."
        canonical="https://quimical.com.br/cookies"
      />
      <Header />
      
      <main className="pt-20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-8">
              Política de Cookies
            </h1>
            
            <div className="prose prose-gray max-w-none">
              <p className="text-muted-foreground mb-6">
                Última atualização: Janeiro de 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  O que são Cookies?
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Cookies são pequenos arquivos de texto armazenados no seu dispositivo quando você visita um site. 
                  Eles são amplamente utilizados para fazer os sites funcionarem de forma mais eficiente e fornecer 
                  informações aos proprietários do site.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Como Utilizamos Cookies
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  A Quimical utiliza cookies para:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Manter você logado no Portal do Cliente</li>
                  <li>Lembrar suas preferências e configurações</li>
                  <li>Melhorar a performance e funcionalidade do site</li>
                  <li>Analisar como nosso site é usado</li>
                  <li>Personalizar seu conteúdo e experiência</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Tipos de Cookies que Utilizamos
                </h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      1. Cookies Essenciais
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      Necessários para o funcionamento básico do site. Incluem cookies de autenticação 
                      e segurança que permitem o acesso ao Portal do Cliente.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      2. Cookies de Performance
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      Coletam informações sobre como os visitantes usam nosso site, como páginas mais 
                      visitadas e mensagens de erro. Estes dados nos ajudam a melhorar o site.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      3. Cookies de Funcionalidade
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      Permitem que o site se lembre de escolhas que você faz (como idioma ou região) 
                      e forneçam recursos aprimorados e mais pessoais.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      4. Cookies de Marketing
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      Utilizados para entregar anúncios mais relevantes para você e seus interesses. 
                      Também podem limitar o número de vezes que você vê um anúncio.
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Cookies de Terceiros
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Nosso site pode conter cookies de terceiros, incluindo:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Google Analytics - para análise de tráfego do site</li>
                  <li>Redes sociais - para integração com plataformas sociais</li>
                  <li>Ferramentas de chat - para suporte ao cliente</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Gerenciando Cookies
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Você pode controlar e/ou excluir cookies conforme desejar. Você pode:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Excluir todos os cookies que já estão no seu computador</li>
                  <li>Configurar seu navegador para impedir que cookies sejam colocados</li>
                  <li>Aceitar cookies apenas de sites específicos</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Nota: Bloquear todos os cookies pode afetar a funcionalidade do nosso site, 
                  especialmente o Portal do Cliente.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Configurações do Navegador
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Para gerenciar cookies, acesse as configurações do seu navegador:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Chrome: Configurações → Privacidade e segurança → Cookies</li>
                  <li>Firefox: Opções → Privacidade e segurança → Cookies</li>
                  <li>Safari: Preferências → Privacidade → Cookies</li>
                  <li>Edge: Configurações → Cookies e permissões de site</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Alterações nesta Política
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Podemos atualizar esta política de cookies ocasionalmente. Recomendamos que você 
                  revisite esta página periodicamente para se manter informado sobre como utilizamos cookies.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-4">
                  Contato
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Se você tiver dúvidas sobre nossa política de cookies, entre em contato:
                </p>
                <div className="mt-4 text-muted-foreground">
                  <p>E-mail: <a href="mailto:privacidade@quimical.com.br" className="text-primary hover:underline">privacidade@quimical.com.br</a></p>
                  <p>Telefone: +55 (11) 4000-0000</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Cookies;
